// import React from 'react';
import NewPaymentLink from './components/NewPaymentLink';

module.exports = NewPaymentLink;
